// import { createStore, applyMiddleware } from "redux";
// import rootReducer from "./reducer/rootReducer.js";
// // import { composeWithDevTools } from "redux-devtools-extension";
// import thunkMiddleware from "redux-thunk";

// const store = createStore(
//     rootReducer, 
//     // composeWithDevTools(applyMiddleware(thunkMiddleware))
//     applyMiddleware(thunkMiddleware)
// );

// export default store;

import { createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import rootReducer from './reducer/rootReducer';

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
